import React from "react";
var __jsx = React.createElement;
import ServicesBlade from './ServicesBlade';
function ServicesBladeAdapter(_ref) {
  var entry = _ref.entry,
    data = _ref.data;
  return __jsx(ServicesBlade, {
    pageUrl: data.DynamicLayoutPage.url || '/services',
    servicesBladeData: entry
  });
}
export default ServicesBladeAdapter;